// What the cloud takes (TUNE Live's cloud.md §2.4 and §2.6), so the portal can say so before it uploads anything.

const MIB = 1024 * 1024;

export const LIMITS = {
  /** A dashboard (`.tunetheme`). */
  dashboardBytes: 128 * MIB,
  /** A config (`.tuneconfig`). */
  configBytes: 2 * MIB,
  /** A datalog, gzipped. */
  datalogBytes: 1024 * MIB,
  diagnosticsBytes: 100 * MIB,
  /** A trip's or a track day's record. */
  recordBytes: 64 * 1024,
  /** Each part of an upload but the last. */
  partBytes: 8 * MIB,
} as const;
